import { connect } from 'react-redux';
import { Action } from 'redux';
import { dispatchAsync } from 'react-redux-dispatch-async';
import { CheckoutDumb } from './Checkout.dumb';
import { AppState } from '../../../common/configuration/app.states';
import { getConnectedUser } from '../../../authContext/usecases/Auth.selectors';
import { getCartProductsRequest, insertOrderRequest } from '../../usecases/General.actions';
import { getStateCart, getStateMagasins } from '../../usecases/General.selectors';
import { Order } from '../../domain/entities/Order';

const mapState = (state: AppState) => ({
  stateCart: getStateCart(state),
  stateConnectedUser: getConnectedUser(state),
  stateMagasins: getStateMagasins(state),
});

const mapDispatch = (dispatch: (a: Action) => void) => ({
  getCartProductsAsync: () => dispatchAsync(dispatch, getCartProductsRequest()),
  insertOrderAsync: (order: Order) => dispatchAsync(dispatch, insertOrderRequest(order)),
});

export const CheckoutSmart = connect(mapState, mapDispatch)(CheckoutDumb);
